import {COMMON_MESSAGE} from '../constant/index';

const initialState = {
  message:null,
};
const CommonMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMON_MESSAGE:
      return {
        ...state,
        message: action.data,
      };
    default:
      return state;
  }
};

export default CommonMessageReducer;
